import React, { useRef } from 'react'
import { colors } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { formatValue } from '@fs/zion-locale'
import { trackEvent } from '@fs/zion-analytics'
import { Player as Lottie } from '@lottiefiles/react-lottie-player'
import { bool, func, number, objectOf, oneOfType, string } from 'prop-types'
import coin from '../../assets/lottieFiles/jump-spin-coin.json'

const pointsCss = css`
  border-radius: 100px;
  padding: 5px 15px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;

  &:focus {
    outline: 2px solid ${colors.blue60};
    outline-offset: 2px;
  }

  &:focus span {
    text-decoration: underline;
  }
`

const lottieStyle = {
  width: '34px',
  height: '34px',
  margin: '-5px',
}

export default function PointsBlock({
  points,
  simple,
  color = colors.gray90,
  backgroundColor = colors.blue03,
  each,
  onClick,
  style,
}) {
  const [t] = useTranslation()
  const coinRef = useRef()
  const handleEvent = () => coinRef.current.play()
  const flexDirection = { flexDirection: simple ? 'row-reverse' : 'row' }
  const Component = onClick ? 'button' : 'div'

  return points ? (
    <Component
      data-testid="points-block"
      type={onClick ? 'button' : undefined}
      css={pointsCss}
      onClick={
        onClick
          ? () => {
              trackEvent({
                event_name: 'Points:BUTTON:CLICK',
              })
              onClick()
            }
          : undefined
      }
      onMouseEnter={handleEvent}
      style={{ ...style, ...flexDirection, backgroundColor, cursor: onClick ? 'pointer' : 'default' }}
    >
      <span
        aria-label={`${t('points.points', `${points} Points`, { points })}`}
        style={{ color, fontWeight: 700, verticalAlign: 'middle', marginInlineStart: '5px', marginInlineEnd: '5px' }}
      >
        {simple ? (
          <>{formatValue(points)}</>
        ) : (
          <>
            {each
              ? t('points.pointsEach', `${points} POINTS EACH`, { points })
              : t('points.points', `${points} POINTS`, { points })}
          </>
        )}
      </span>
      <Lottie src={coin} style={lottieStyle} ref={coinRef} loop={false} autoplay={false} />
    </Component>
  ) : null
}

PointsBlock.propTypes = {
  points: number,
  simple: bool,
  color: string,
  backgroundColor: string,
  each: bool,
  onClick: func,
  style: objectOf(oneOfType([string, number])),
}
